import React from 'react';
import { Grid, Table, Pagination, Segment, Button, Icon } from 'semantic-ui-react';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import moment from 'moment';

const Orders = ({ loading, orderData, totalPages, activePage, onPageChange, history }) => {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <Grid centered padded style={{ marginTop: '0px', padding: '10vh' }}>
      <Helmet>
        <title>Orders Listing</title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Orders Listing
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={3} textAlign="center">
          <Button basic color="blue" onClick={() => history.push('/orders_search')}>
            Search Orders
            <Icon style={{ marginLeft: '0.5em' }} name="search" />
          </Button>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={14}>
          <Table celled fixed>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Order Id</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Amount</Table.HeaderCell>
                <Table.HeaderCell>Payment Id</Table.HeaderCell>
                <Table.HeaderCell>User Id</Table.HeaderCell>
                <Table.HeaderCell>Phone</Table.HeaderCell>
                <Table.HeaderCell>Coupon</Table.HeaderCell>
                <Table.HeaderCell>Cashback</Table.HeaderCell>
                <Table.HeaderCell>VM Name</Table.HeaderCell>
                <Table.HeaderCell>VM City</Table.HeaderCell>
                <Table.HeaderCell>Created On</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {orderData &&
                orderData.length &&
                orderData.map(el => (
                  <Table.Row
                    positive={el.status === 'completed'}
                    negative={el.status === 'cancelled'}
                  >
                    <Table.Cell>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <Link
                        to={`/orders/details/${el.id}`}
                        style={{
                          textDecoration: 'underline',
                          color: '#603cba',
                          wordWrap: 'break-word'
                        }}
                      >
                        {el.id}
                      </Link>
                    </Table.Cell>
                    <Table.Cell style={{ wordWrap: 'break-word' }}>{el.status}</Table.Cell>
                    <Table.Cell>{el.amount}</Table.Cell>
                    <Table.Cell>{el.payment_id}</Table.Cell>
                    <Table.Cell>{el.user_id}</Table.Cell>
                    <Table.Cell>{el.phone || 'N/A'}</Table.Cell>
                    <Table.Cell>{el.coupon || 'N/A'}</Table.Cell>
                    <Table.Cell>{el.cashback || 'N/A'}</Table.Cell>
                    <Table.Cell>{el.VM_name}</Table.Cell>
                    <Table.Cell>{el.VM_city || 'N/A'}</Table.Cell>
                    <Table.Cell style={{ wordWrap: 'break-word' }}>
                      {/* {new Date(el.created_at).toLocaleString()} */}
                      {moment
                        .utc(el.created_at)
                        .local()
                        .format('DD-MM-YYYY HH:mm:ss')}
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={5}>
          <Pagination
            defaultActivePage={activePage}
            totalPages={Math.floor(totalPages)}
            style={{ marginBottom: '5vh' }}
            onPageChange={onPageChange}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default withRouter(Orders);



// WEBPACK FOOTER //
// ./src/Modules/Orders/component.jsx